import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import { Subject, Subscription, takeUntil } from "rxjs";
import {CommonService} from "../../../services/common.service";
import { screenType } from "../../../core/shared.selectors";
import { Store } from "@ngrx/store";

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['../styles.css', './dropdown.component.css']
})
export class DropdownComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('select') input: ElementRef | undefined;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  @Input() loading: boolean = false;
  @Input() label: string = '';
  @Input() options: { key: any, value: string, disabled?: boolean }[] = [];
  @Input() enableClearSelection: boolean = false;
  @Input() parentFormGroup: FormGroup = new FormGroup({});
  @Input() controlName: string = '';
  @Input() error: string = '';
  @Input() placeholder: string = '';
  @Input() focus: boolean = false;
  @Input() enableMultiple: boolean = false;
  @Input() optionsPanelClassName: string = '';
  @Input() type: string = '';
  @Input() disableAllOptions = false;
  @Input() defaultValue: any;
  @Input() tooltipText :string=''
  @Output() checkForErrors: EventEmitter<any> = new EventEmitter();

  fieldSubscription: Subscription | undefined;

  isRequired: boolean = false;
  isDisabled: boolean = false;
  optionsDisabled: boolean = false;
  selectedSpecialOption: number | null = null;
  screenType: any;


  constructor(
    private commonService: CommonService,
    private store: Store
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.['focus']?.currentValue) {
      const clientArea = $('#client_area');
      const y = clientArea.scrollTop() +
                this.input?.nativeElement.getBoundingClientRect().top -
                this.commonService.headerRemOffsetCalculator()

      clientArea.scrollTop(y);
    }
  }

  // Do not show field as touched and having error when clicked outside the field
  @HostListener('focusout', ['$event'])
  onBlur(event: any) {
    if (!this.error) {
      setTimeout(() => {
        this.parentFormGroup?.controls[this.controlName].markAsUntouched();
      }, 150);
    }
  }

  ngOnInit(): void {
    const control = this.parentFormGroup.controls[this.controlName];
    this.isDisabled = control?.status === 'DISABLED';
    this.fieldSubscription = control?.valueChanges.subscribe((value) => {
      if (this.enableMultiple) {
        if (value?.includes(-3)) {
          this.optionsDisabled = true;
          this.selectedSpecialOption = -3;
          this.parentFormGroup.controls[this.controlName].patchValue([-3], {emitEvent: false})
        } else if (value?.includes(-1)) {
          this.optionsDisabled = true;
          this.selectedSpecialOption = -1;
          this.parentFormGroup.controls[this.controlName].patchValue([-1], {emitEvent: false})
        } else if (value?.includes(-2)) {
          let selectedValues = [];
          this.options?.forEach(option => {
            selectedValues.push(option.key);
          });
          if (selectedValues.includes(-1)) {
            const index = selectedValues.indexOf(-1);
            selectedValues.splice(index, 1);
          }
          this.parentFormGroup.controls[this.controlName].patchValue([...selectedValues], {emitEvent: false});
          this.optionsDisabled = false;
          this.selectedSpecialOption = null;
        } else {
          this.optionsDisabled = false;
          this.selectedSpecialOption = null;
        }
      }

      // If field is marked as touched, mark it as untouched
      if (this.parentFormGroup?.controls[this.controlName].touched) {
        this.parentFormGroup?.controls[this.controlName].markAsUntouched();
      }

      // Get errors on the form field
      const errors = this.parentFormGroup.controls[this.controlName].errors;

      // If errors exist, handle it
      if (errors) {
        // Clear errors on the form field
        this.parentFormGroup.controls[this.controlName].setErrors(null);

        // Clear out the error messages on the screen (parent component)
        this.checkForErrors.emit(this.controlName);

        // Add errors again to the form field for showing messages in the future
        this.parentFormGroup.controls[this.controlName].setErrors(errors);
      } else {
        // Clear out the error messages on the screen (parent component)
        this.checkForErrors.emit(this.controlName);
      }
    });

    // Check if field is required
    if (control?.validator) {
      const validator = control.validator({} as AbstractControl);
      this.isRequired = !!(validator && validator['required']);
    }

    this.store.select(screenType).pipe(takeUntil(this.onDestroy)).subscribe(screenType => {
      this.screenType = screenType;
    });
  }

  clearSelection($event: Event) {
    $event.stopPropagation();
    this.parentFormGroup.controls[this.controlName].setValue(this.defaultValue || '');
    this.parentFormGroup.markAsDirty();
  }

  ngOnDestroy() {
    this.fieldSubscription?.unsubscribe();
  }

}
